import { Container, RowEdit, LineTable, CellLine, TableContent } from "./style";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Api from "../../../../adapters/api/api";

import { Table, Button, Input, FormGroup, Col, Row } from "reactstrap";
import { FiPlus } from "react-icons/fi";
import { useToast } from "../../../../hooks/Toast";

interface IContractCancelled {
  service_provider_apresentation_name: string;
  contract_id: string;
  service_provider_name: "string";
  user_name: string;
  cancelled_at: string;
  service_plan: string;
  service_type: string;
  show_value: string;
  contract_cancelled_id: string;
}

export const ContractCanceled: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [contractCanceled, setContractCanceled] = useState<
    Array<IContractCancelled>
  >([]);

  useEffect(() => {
    loadContractCanceled();
  }, []);

  const loadContractCanceled = async () => {
    try {
      const response = await Api.get(`admin/contract/cancelled`);
      setContractCanceled(response.data);
    } catch (err: any) {
      const responseData = err.response?.data;
      console.log(err);
      if (err.response?.status === 422 && responseData?.data) {
        const message = Object.entries(responseData.data)
          .map(([field, error]) => `${field} - ${error}`)
          .join(", ");

        addToast({
          title: responseData.message || "Parâmetros inválidos",
          description: message,
          type: "error",
        });
      } else {
        addToast({
          title: "Erro ao buscar usuários",
          description:
            "Ocorreu um erro inesperado ao processar sua requisição. Tente novamente mais tarde.",
          type: "error",
        });
      }
    }
  };

  const sliceText = (texto: string, limite = 30) => {
    return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
  };

  const handleClick = (contract_id: string) => {
    navigate(`/contractCanceled/${contract_id}/info`);
  };

  return (
    <>
      <Container>
        <div>
          <TableContent>
            <Table hover>
              <thead>
                <tr>
                  <th>Nome Apresentação</th>
                  <th>Nome Contratante</th>
                  <th>Serviço</th>
                  <th>Tipo Serviço</th>
                  <th>Valor Show Contratado</th>
                  <th>Data Cancelamento</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {contractCanceled &&
                  contractCanceled.map((contract: IContractCancelled) => {
                    return (
                      <LineTable
                        key={contract.contract_id}
                        active={false}
                        onClick={() =>
                          handleClick(contract.contract_cancelled_id)
                        }
                      >
                        <CellLine>
                          {contract.service_provider_apresentation_name}
                        </CellLine>
                        <CellLine>{contract.service_type}</CellLine>
                        <CellLine> {contract.user_name} </CellLine>
                        <CellLine>{sliceText(contract.service_plan)}</CellLine>
                        <CellLine>{contract.show_value}</CellLine>
                        <CellLine>{contract.cancelled_at}</CellLine>
                        <CellLine>
                          <RowEdit>
                            <FiPlus
                              size={25}
                              color="#a09e95"
                              onClick={() => {}}
                            />
                          </RowEdit>
                        </CellLine>
                      </LineTable>
                    );
                  })}
              </tbody>
            </Table>
          </TableContent>
        </div>
      </Container>
    </>
  );
};
